<template>
  <div class="loading_content" v-if="visible">
    <template v-if="theme == 'circle'">
      <div class="loading_circle">
        <van-loading vertical size="28px" class="loading_icon" color="#fff">加载中...</van-loading>
      </div>
    </template>
    <div v-if="showIcon && theme != 'circle'" class="loading_inner">
      <div
        class="api_loading"
        :class="{ api_loading_light: theme == 'light'}"
      ></div>
      <div class="loading_text" v-show="theme == 'bike'">加载中...</div>
    </div>

    <van-loading vertical size="28px" class="loading_inner" color="#8196cb" v-if="showUploadLoading">
      <!-- 上传中，请稍后 -->
    </van-loading>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      showIcon: true, // 如果是分页加载的数据，需要判断当前分页是不是第一页， 第一页则显示加载骑车图标，其他页不需要显示加载图标
      showUploadLoading: false, //上传接口的loading
      theme: 'dark' //默认是dark, light
    }
  },
  methods: {
    show(params, isUploadAPI, theme) {
      this.visible = true
      this.theme = theme || 'dark'
      console.log(this.theme, 'ppppppp')
      if (isUploadAPI) {
        this.showUploadLoading = true
        this.showIcon = false
        return
      }
      this.showUploadLoading = false
      //  判断是否是列表页面的加载： 如果是分页加载的数据，需要判断当前分页是不是第一页， 第一页则显示加载骑车图标，其他页不需要显示加载图标
      if (this.judgeType(params) == 'object' && ('page' in params || 'pageNo' in params || 'pageNum' in params)) {
        let page = params.page || params.pageNo || params.pageNum
        if (page && page > 1) {
          this.showIcon = false
        } else {
          this.showIcon = true
        }
      } else if (this.judgeType(params) == 'string') {
        let current_page = this.getUrlParam(params, 'page') || this.getUrlParam(params, 'pageNo') || this.getUrlParam(params, 'pageNum')
        if (current_page && current_page > 1) {
          this.showIcon = false
        } else {
          this.showIcon = true
        }
      } else {
        this.showIcon = true
      }
    },
    hide() {
      this.visible = false
    }
  }
}
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/components/LoadingService/index.vue